import { render, staticRenderFns } from "./Q7.vue?vue&type=template&id=08b255ce&"
import script from "./Q7.vue?vue&type=script&lang=js&"
export * from "./Q7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports